<div class="error-resolution-dialog" #printArea>
  <div class="dialog-header">
    <img src="assets/images/transend-logo-wide.svg" alt="Transend Logo" class="logo" />

    <span class="spacer"></span>

    <button mat-icon-button class="no-print" (click)="onPrint()" aria-label="Print">
      <mat-icon>print</mat-icon>
    </button>

    <button mat-icon-button class="cancel-button no-print" (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <h1 class="dialog-title">Error Resolution Disclosure</h1>

    <p class="content-text">
      IN CASE OF ERRORS OR QUESTIONS ABOUT YOUR DEBIT CARD transaction, please call us at 833-378-3841, or email us at
      <a href="mailto:support@transendfinancial.com">support&#64;transendfinancial.com</a> no later than sixty (60) days
      after
      the statement on which the error or problem appeared.
    </p>

    <p class="content-text">You must provide us with:</p>
    <ol class="content-list">
      <li>Your name and account number</li>
      <li>Description of the error or transaction which you are unsure about and explain as clearly as possible why you
        believe it is an error.</li>
      <li>The dollar amount of the error</li>
    </ol>

    <p class="content-text">
      We will determine whether an error occurred within ten (10) business days after we hear from you and will correct
      any error promptly.
      If more time is needed, we may take up to forty-five (45) days to investigate your complaint or question. If
      additional time is
      needed to conduct our research, we will provide you with a provisional credit until we have completed our
      investigation.
    </p>

    <p class="content-text">
      Errors involving new accounts may take up to ninety (90) business days to investigate and up to twenty (20)
      business days to credit
      your account for the amount you think is in error.
    </p>

    <p class="content-text">
      We will advise you of the results of our investigation within three (3) business days after completing our
      investigation. If we
      decide that an error did not occur, we will withdraw any previously issued provisional credit placed in your
      account and send you a
      written explanation of our decision.
    </p>

    <p class="content-text">**Note – you may ask for copies of the documents that we used in our
        investigation.</p>
  </div>
</div>